// extracted by mini-css-extract-plugin
export default {"skill":"Skills_skill__kMMun","skillDiv":"Skills_skillDiv__33wOj","logo":"Skills_logo__Cf1ZB","skillH3":"Skills_skillH3__jdczu"};